var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublishedHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.086,
    height: 30,
    viewBox: "0 0 35.086 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Published",
    transform: "translate(265.945 -7.443)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M-234.424,7.443h-23.682a3.55,3.55,0,0,0-3.544,3.544V22.421h0a7.955,7.955,0,0,0-4.294,7.064,7.958,7.958,0,0,0,7.958,7.958,7.934,7.934,0,0,0,5.705-2.412H-234.4a3.55,3.55,0,0,0,3.544-3.544v-20.5A3.582,3.582,0,0,0-234.424,7.443ZM-257.987,35.5A6.02,6.02,0,0,1-264,29.485a6.02,6.02,0,0,1,6.013-6.013,6.02,6.02,0,0,1,6.013,6.013A6.02,6.02,0,0,1-257.987,35.5Zm7.1-2.42a7.923,7.923,0,0,0,.858-3.593,7.925,7.925,0,0,0-.728-3.325,6.987,6.987,0,0,1,3.175-.764h2.632a7.686,7.686,0,0,1,7.421,7.682Zm.079-14.494a4.718,4.718,0,0,1,4.541-4.86,4.69,4.69,0,0,1,4.541,4.86,4.7,4.7,0,0,1-4.541,4.86A4.718,4.718,0,0,1-250.807,18.584Zm18,12.9h-.022a1.6,1.6,0,0,1-1.591,1.591h-1.152a9.836,9.836,0,0,0-6.632-9.2,6.926,6.926,0,0,0,2.436-5.312,6.662,6.662,0,0,0-6.493-6.812,6.662,6.662,0,0,0-6.493,6.812,6.926,6.926,0,0,0,2.436,5.312,9.032,9.032,0,0,0-1.464.621,7.941,7.941,0,0,0-6.2-2.97,7.99,7.99,0,0,0-1.712.187h0V10.987A1.6,1.6,0,0,1-258.107,9.4h23.7a1.6,1.6,0,0,1,1.592,1.591Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M-247.047,67.139l-2.778,2.946-1.2-1.16a.972.972,0,0,0-1.375-.02.972.972,0,0,0-.02,1.375l.044.042,1.909,1.844.075.055c.026.019.049.042.075.058l.084.042.081.042a.965.965,0,0,0,.1.029.446.446,0,0,0,.071.019.818.818,0,0,0,.178,0,1.254,1.254,0,0,0,.191,0h.065a.32.32,0,0,0,.12-.039.453.453,0,0,0,.078-.042.7.7,0,0,0,.1-.052l.075-.062.075-.065,3.468-3.679a.972.972,0,0,0-.039-1.374A.972.972,0,0,0-247.047,67.139Z",
    transform: "translate(-8.954 -40.142)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishedHover);
export default __webpack_public_path__ + "static/media/PublishedHover.8ed50807ad71a89878f851c026f3e62b.svg";
export { ForwardRef as ReactComponent };